<template>
  <div id="app_content" class="reserved">
    <div class="container">
      <div class="section-top">
        <a v-if="categoria" class="link-ret dark-gray filter" @click="toggleFilter">
          {{ trans.get("b2b.article.product-filter") }}
        </a>

        <b-sidebar
            type="is-light"
            :fullheight="true"
            :fullwidth="false"
            :overlay="true"
            :right="false"
            v-model="openFilter"
        >
          <!--            <div id="overlay-filter" class="overlay-filter">-->
          <productfilter  @closeMe="toggleFilter"  @applyFilter="getFilterData" :key="filterKey"/>
          <!--              <div class="emptyoverlay" @click="toggleFilter"></div>-->
          <!--            </div>-->
        </b-sidebar>
      </div>
    </div>

    <div class="section-flex-collection container" >

        <search v-if="filterMounted" :search-data="filterData" :key="searchKey"/>

      <div v-if="articles === null">
        <p>{{ trans.get("b2b.article.no-articles-found") }}</p>
      </div>
      <div class="wrap-element row" v-else-if="articles && isMounted">
        <div v-if="!filterMounted" class="col-md-12">
          <h1>
            <span v-if="articles[0].macrofamily.descrizione">
             <a :href="url('/b2b/macrofamily-article/' + articles[0].family.codice)"> {{ articles[0].macrofamily.descrizione }}</a>
            </span>
            <span v-else>
             <a :href="url('/b2b/macrofamily-article/' + articles[0].family.codice)"> {{ articles[0].macrofamily.codice }}</a>
            </span>
            <i class="fas fa-angle-right"></i>
            <span v-if="articles[0].family.descrizione">
              {{ articles[0].family.descrizione }}
            </span>
            <span v-else>
              {{ articles[0].family.des_estesa }}
            </span>
          </h1>
        </div>
        <div v-if="!filterMounted" class="col-md-12">
          {{ trans.get("b2b.article.products") }}: {{articles.length}}
        </div>
        <div
            class="element col-md-6 col-lg-4 col-xl-3"
            v-for="family in articles"
            v-if="filterData === null"
        >
          <productcard
              v-if="isMounted"
              class="productcard"
              :product="family"
              :customer="true"
              :family="family.cod_famiglia"
              :categoria="categoria"
              :color="family.cod_colore"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productcard from "../product-card";
import productfilter from "../product-filter";

export default {
  components: {
    productcard,
    productfilter,
  },

  data: function () {
    return {
      filterKey: 0,
      loading: false,
      openFilter: false,
      isMounted: false,
      articles: null,
      filterData: null,
      filterMounted: false,
      categoria: null,
      searchKey: 0,
    };
  },
  mounted: function () {

    this.loadArticles();
  },
  watch: {
    "$store.state.filterKey": function () {
      this.filterKey = this.$store.state.filterKey;
    },
  },
  methods: {

    forceRerender: function () {
      this.searchKey += 1;
    },
    getFilterData: function (searchData) {
      this.forceRerender();
      this.filterMounted = true;
      this.filterData = searchData;
    },
    toggleFilter: function () {
      //$("#overlay-filter").toggle();
      this.openFilter = !this.openFilter;
      this.$store.dispatch('refreshFilter')
    },
    getMacrofamilyCode: function () {
      if (this.articles) {
        if (sessionStorage.macrofam) {
          sessionStorage.macrofam = this.articles[0].cod_macrofamiglia;
        } else {
          sessionStorage.setItem(
              "macrofam",
              this.articles[0].cod_macrofamiglia
          );
        }
      }
    },
    loadArticles: function () {
      var vue = this;
      vue.loading = true;
      let pathname = window.location.pathname.split("/");
      let cod_family = pathname[pathname.length - 1];
      let categoria = null
      switch (cod_family) {
        case '4TOOLS':
          categoria = false
          break
        case '4CLEAN':
          categoria = false
          break
        case '4CUSTOM':
          categoria = false
          break
        case 'TAG':
          categoria = false
          break
        default:
          categoria = true
      }
      //console.log(cod_family)
      this.categoria = categoria
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: cod_family,
          type: (categoria) ? "category" : "nocategory",

        },
      })
          .then((res) => {
            //console.log(res.data)
            if (res.data.family.length > 0) {
              this.articles = res.data.family;

            }
            vue.isMounted = true;

            this.getMacrofamilyCode();
          })
          .catch((err) => {
            vue.loading = false;

            vue.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },

    // loadArticles: function () {
    //   var vue = this;
    //   vue.loading = true;
    //   let pathname = window.location.pathname.split('/');
    //   let cod_family = pathname[pathname.length - 1];
    //   axios({
    //     method: 'get',
    //     url: window.location.origin + '/data/get-family',
    //     params: {
    //       cod: cod_family,
    //       type: 'category',
    //     }
    //   })
    //       .then(res => {
    //
    //
    //
    //         this.articles = res.data.family
    //         console.log('articles: ', res.data.family)
    //
    //         vue.isMounted = true;
    //       })
    //       .catch(err => {
    //
    //         vue.loading = false;
    //
    //         vue.$store.commit('add_message', {
    //           type: 'error',
    //           message: err.response.data.message
    //         })
    //
    //       })
    // },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  span {
    display: inline-block;
    text-transform: lowercase;
    font-size: 20px;

    &:first-letter {
      text-transform: uppercase;
    }
    &:last-child {
      text-decoration: underline;
    }
  }
  i {
    font-size: 18px;
  }
}
.reserved {
  .section-top {
    max-width: 1200px;
    margin: auto;
    padding-bottom: 20px;

    .filter {
      width: 100%;
      height: 70px;
      margin-left: 14px;
    }

    .overlay-filter {
      display: none;
      height: calc(100vh - 80px);
      width: 100vw;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.7);
      left: 0;
      top: 80px;
      z-index: 2;
      backdrop-filter: blur(4px);

      &.show {
        display: flex;
      }

      &.hide {
        display: none;
      }

      .emptyoverlay {
        width: 100%;
        height: 100%;
      }
    }
  }

  .section-flex-collection {
    // display: flex;
    // align-items: center;
    // justify-content: center;

    .wrap-element {
      // max-width: 1200px;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // flex-wrap: wrap;

      .element {
        margin: 30px 0;

        .product-card {
          margin: 0 13px 80px;
        }
      }
    }
  }

  b-sidebar {
    height: calc(100vh - 80px);
  }
}

.b-sidebar .sidebar-content.is-fullheight {
  /* height: 100%; */
  max-height: 100%;
  overflow: hidden;
  overflow-y: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  top: 80px;
  height: calc(100vh - 80px);
}

@media (min-width: 768px) {
  .reserved {
    .section-top {
      padding: 50px 0;

      .filter {
        width: 360px;
      }
    }
  }
}
</style>
